import React, {FC} from "react"

import Flex from "@irati/ui/src/Flex"
import {Card} from "@irati/ui/src/Layout"
import {Body, H4} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import authentication from "@irati/auth"

interface Props {
  onClick: () => void
}

const Welcome: FC<Props> = ({onClick}) => {
  const theme = useTheme()
  const {formatMessage} = useIntl()
  const businessName = authentication.business().businessName

  return (
    <Card marginBottom padding={2} bgColor={theme.colors.success}>
      <Flex justifyContent="space-between" alignItems="center">
        <Flex gap={1} alignItems="center">
          <img src={formatMessage({id: "admin.components.yourPerkboxStory.welcome.img"})} height={32} width={32} />
          <H4 color={theme.colors.greys.white}>
            <FormattedMessage id="admin.components.yourPerkboxStory.welcome.title" />
          </H4>
          <Body small color={theme.colors.greys.white}>
            <FormattedMessage id="admin.components.yourPerkboxStory.welcome.text" values={{businessName}} />
          </Body>
        </Flex>
        <Button inverted onClick={onClick}>
          <FormattedMessage id="admin.components.yourPerkboxStory.welcome.btn" />
        </Button>
      </Flex>
    </Card>
  )
}

export default Welcome
